import type { Role, User } from "@/services/types/auth";

/**
 * Mock 用户库 · v1 用 · 真接 SSO 后此文件作为 fallback / dev fixture
 */
const initial = (name: string) => name.charAt(0).toUpperCase();

const make = (id: string, name: string, email: string, role: Role): User => ({
  id,
  name,
  email,
  initial: initial(name),
  role,
});

export const MOCK_USERS: User[] = [
  make("u-001", "Hao 超管", "hao@youtu.travel", "tech_admin"),
  make("u-002", "老板李", "boss@youtu.travel", "owner"),
  make("u-003", "OP 经理王", "op-mgr@youtu.travel", "op_manager"),
  make("u-004", "OP 主管张", "op-sup@youtu.travel", "op_supervisor"),
  make("u-005", "OP 小赵", "op@youtu.travel", "op"),
  make("u-006", "财务陈", "finance@youtu.travel", "finance"),
  make("u-007", "客户经理林", "am@youtu.travel", "account_manager"),
  make("u-008", "技术管理员吴", "tech@youtu.travel", "tech_admin"),
];

export function mockLogin(email: string, _password: string): User | null {
  return MOCK_USERS.find((u) => u.email === email) ?? MOCK_USERS[0];
}

export function mockSsoLogin(email: string): User | null {
  return MOCK_USERS.find((u) => u.email === email) ?? MOCK_USERS[0];
}
